"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PubSubRedis", {
    enumerable: true,
    get: function() {
        return PubSubRedis;
    }
});
const _common = require("@nestjs/common");
const _ioredis = /*#__PURE__*/ _interop_require_default(require("ioredis"));
const _redisHelpers = require("~/helpers/redisHelpers");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let PubSubRedis = class PubSubRedis {
    static async init() {
        if (!PubSubRedis.available) {
            return;
        }
        PubSubRedis.redisClient = new _ioredis.default((0, _redisHelpers.getRedisURL)(_redisHelpers.NC_REDIS_TYPE.JOB));
        PubSubRedis.redisSubscriber = new _ioredis.default((0, _redisHelpers.getRedisURL)(_redisHelpers.NC_REDIS_TYPE.JOB));
        PubSubRedis.initialized = true;
    }
    static async publish(channel, message) {
        if (!PubSubRedis.initialized) {
            if (!PubSubRedis.available) {
                return;
            }
            await PubSubRedis.init();
        }
        try {
            if (typeof message === 'string') {
                await PubSubRedis.redisClient.publish(channel, message);
            } else {
                await PubSubRedis.redisClient.publish(channel, JSON.stringify(message));
            }
        } catch (e) {
            PubSubRedis.logger.error(e);
        }
    }
    /**
   *
   * @param channel
   * @param callback
   * @returns Returns a callback to unsubscribe
   */ static async subscribe(channel, callback) {
        if (!PubSubRedis.initialized) {
            if (!PubSubRedis.available) {
                return;
            }
            await PubSubRedis.init();
        }
        await PubSubRedis.redisSubscriber.subscribe(channel);
        const unsubscribe = async (keepRedisChannel = false)=>{
            // keepRedisChannel is used to keep the channel open for other subscribers
            if (!keepRedisChannel) await PubSubRedis.redisSubscriber.unsubscribe(channel);
            PubSubRedis.redisSubscriber.off('message', onMessage);
        };
        const onMessage = async (messageChannel, message)=>{
            if (channel !== messageChannel) {
                return;
            }
            try {
                message = JSON.parse(message);
            } catch (e) {}
            await callback(message, unsubscribe);
        };
        PubSubRedis.redisSubscriber.on('message', onMessage);
        return unsubscribe;
    }
};
PubSubRedis.initialized = false;
PubSubRedis.available = (0, _redisHelpers.getRedisURL)(_redisHelpers.NC_REDIS_TYPE.JOB) ? true : false;
PubSubRedis.logger = new _common.Logger(PubSubRedis.name);
